import { render, staticRenderFns } from "./ModalGlobal.vue?vue&type=template&id=789a7e61&lang=pug"
import script from "./ModalGlobal.vue?vue&type=script&lang=js"
export * from "./ModalGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports